// Sample questions for testing the quiz game
export const sampleQuestions = [
  // Mathematics - Class 1
  {
    question: "What is 2 + 3?",
    options: ["4", "5", "6", "7"],
    correctAnswer: "5",
    subject: "Math",
    chapter: "Chapter 1",
    class: "1",
    difficulty: "easy",
    hint: "Count on your fingers: 2 fingers plus 3 more fingers"
  },
  {
    question: "Which number comes after 9?",
    options: ["8", "10", "11", "12"],
    correctAnswer: "10",
    subject: "Math",
    chapter: "Chapter 1",
    class: "1",
    difficulty: "easy",
    hint: "Think about counting from 1 to 10"
  },
  {
    question: "How many sides does a triangle have?",
    options: ["2", "3", "4", "5"],
    correctAnswer: "3",
    subject: "Math",
    chapter: "Chapter 2",
    class: "1",
    difficulty: "easy",
    hint: "Look at the shape of a slice of pizza"
  },

  // Science - Class 1
  {
    question: "Which animal gives us milk?",
    options: ["Dog", "Cat", "Cow", "Lion"],
    correctAnswer: "Cow",
    subject: "Science",
    chapter: "Chapter 1",
    class: "1",
    difficulty: "easy",
    hint: "This animal says 'moo' and lives on a farm"
  },
  {
    question: "What do plants need to grow?",
    options: ["Only water", "Only sunlight", "Water and sunlight", "Nothing"],
    correctAnswer: "Water and sunlight",
    subject: "Science",
    chapter: "Chapter 1",
    class: "1",
    difficulty: "medium",
    hint: "Plants are like us - they need food and drink, but their food comes from the sun"
  },

  // EVS - Class 1
  {
    question: "Which of these is a fruit?",
    options: ["Carrot", "Apple", "Onion", "Potato"],
    correctAnswer: "Apple",
    subject: "EVS",
    chapter: "Chapter 1",
    class: "1",
    difficulty: "easy",
    hint: "This is red or green and grows on trees"
  },
  {
    question: "What should we do before eating?",
    options: ["Watch TV", "Wash hands", "Play games", "Sleep"],
    correctAnswer: "Wash hands",
    subject: "EVS",
    chapter: "Chapter 2",
    class: "1",
    difficulty: "easy",
    hint: "This keeps germs away from our food"
  },

  // English - Class 1
  {
    question: "How many letters are there in the English alphabet?",
    options: ["24", "25", "26", "27"],
    correctAnswer: "26",
    subject: "English",
    chapter: "Chapter 1",
    class: "1",
    difficulty: "medium",
    hint: "Count from A to Z"
  },
  {
    question: "Which is the first letter of the alphabet?",
    options: ["B", "A", "C", "D"],
    correctAnswer: "A",
    subject: "English",
    chapter: "Chapter 1",
    class: "1",
    difficulty: "easy",
    hint: "This letter looks like a tent"
  },

  // Mathematics - Class 2
  {
    question: "What is 15 + 7?",
    options: ["20", "21", "22", "23"],
    correctAnswer: "22",
    subject: "Math",
    chapter: "Chapter 1",
    class: "2",
    difficulty: "medium",
    hint: "Break it down: 15 + 5 = 20, then add 2 more"
  },
  {
    question: "How many minutes are in 1 hour?",
    options: ["50", "60", "70", "80"],
    correctAnswer: "60",
    subject: "Math",
    chapter: "Chapter 3",
    class: "2",
    difficulty: "medium",
    hint: "Look at a clock - count the small marks around it"
  },

  // Science - Class 2
  {
    question: "Which part of the plant makes food?",
    options: ["Roots", "Stem", "Leaves", "Flowers"],
    correctAnswer: "Leaves",
    subject: "Science",
    chapter: "Chapter 2",
    class: "2",
    difficulty: "medium",
    hint: "These are green and use sunlight to make food"
  }
];

// Function to add sample questions to database
export const addSampleQuestions = async () => {
  try {
    for (const question of sampleQuestions) {
      const response = await fetch('/api/quiz/questions', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          ...question,
          createdBy: 'System'
        })
      });
      
      if (response.ok) {
        console.log(`Added question: ${question.question.substring(0, 30)}...`);
      }
    }
    console.log('All sample questions added successfully!');
  } catch (error) {
    console.error('Error adding sample questions:', error);
  }
};